import React, { Component } from 'react';
import CitySettingsForm from '../../../components/SiteAdmin/CitySettingsForm/CitySettingsForm'
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';

import Loader from '../../../components/Common/Loader/Loader';

import getAllHomePageSettings from './getAllHomePageSettings.graphql';
import { withQuery } from '../../../hoc/withGraphql';


export class CitySettings extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired
    }
    static defaultProps = {
        data: {
            loading: true
        }
    }
    render() {
        const { data: { loading, getAllHomePageSettings } } = this.props;
        let initialValues = {};
        let homepageCollection = {};

        getAllHomePageSettings && getAllHomePageSettings.homePageData.map((item) => {
            if (item?.dynamicHomePageSettings && item?.dynamicHomePageSettings?.length > 0) {
                homepageCollection[item?.name] = item?.dynamicHomePageSettings.map(data => ({
                    value: data?.value || null,
                    language: data?.language || 'en-US',
                }))
            } else {
                homepageCollection[item?.name] = item?.value
            }
        })
        return (
            <Loader type={"page"} show={loading}>
                {!loading && <CitySettingsForm initialValues={homepageCollection} />}
            </Loader>
        )

    }
}

export default compose(withQuery(getAllHomePageSettings, {
    options: (props) => ({
        variables: {
            id: props.id
        },
        fetchPolicy: 'network-only',
        ssr: false
    })
}))(CitySettings)
